import {HeadProjectProps} from '@specials/frontend-head';

import {envs} from '@/envs';

const headConfig: Omit<HeadProjectProps, 'wrapper'> = {
  pwa: false,
  cdnUrl: envs.APP_STATIC_BASE_URL,
  title: 'Секрет конфет',
  description: 'Ваши траты за год в новогоднем подарке от Т‑Банка',
  keywords: [],
  viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no',
  themeColor: 'white',
  social: {
    title: 'Секрет конфет',
    description: 'Ваши траты за год в новогоднем подарке от Т‑Банка',
    image: `${envs.APP_STATIC_URL}/share/share_fb.png`,
    imageTwitter: `${envs.APP_STATIC_URL}/share/share_tw.png`,
    imageVk: `${envs.APP_STATIC_URL}/share/share_vk.png`,
    url: envs.APP_PROJECT_URL,
    appIdFb: 'TODO',
  },
};

export default headConfig;
